import EventEmitter from 'events'
import SocketService from './SocketService.js'

class BrowserService extends EventEmitter {
  constructor () {
    super()
    SocketService.on('danmaku.module.browserView.onMessage', data => {
      this.emit(data.channel, data.data)
    })
  }

  sendAcceptModuleNames (moduleNames) {
    SocketService.sendAcceptModuleNames(moduleNames)
  }
}

export default new BrowserService()



// WEBPACK FOOTER //
// ./src/container/BrowserView.js